function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "m406.550781 365.65625 105.449219-176.886719v-166.984375c0-11.734375-9.550781-21.285156-21.285156-21.285156-11.738282 0-21.289063 9.550781-21.289063 21.285156v131.824219l-114.578125 118.503906-21.566406-20.851562 61.25-63.34375c7.65625-8.972657 7.164062-22.570313-1.347656-30.945313-8.886719-8.742187-23.269532-8.667968-32.058594.179688l-90.128906 90.691406v154.914062h135.550781v-37.101562zm0 0"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m241.003906 402.757812v-154.914062l-90.128906-90.691406c-8.789062-8.84375-23.171875-8.925782-32.058594-.179688-8.511718 8.375-9.003906 21.972656-1.347656 30.945313l61.246094 63.34375-21.5625 20.851562-114.578125-118.503906v-131.824219c0-11.734375-9.550781-21.285156-21.289063-21.285156-11.734375 0-21.285156 9.550781-21.285156 21.285156v166.984375l105.449219 176.886719v37.101562zm0 0"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -54 512 511",
    width: "512pt"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/hands.2caa3fbf.svg";
export { SvgComponent as ReactComponent };